// Categorías sugeridas por rubro, para que un negocio nuevo no arranque vacío.

export const RUBRO_CATEGORIES: Record<string, string[]> = {
  kiosco: ['Golosinas', 'Bebidas', 'Cigarrillos', 'Galletitas', 'Snacks', 'Helados', 'Almacén', 'Varios'],
  almacen: ['Almacén', 'Bebidas', 'Lácteos', 'Fiambrería', 'Limpieza', 'Perfumería', 'Panificados', 'Verdulería'],
  perfumeria: ['Perfumes', 'Cuidado personal', 'Cabello', 'Maquillaje', 'Higiene', 'Bebés', 'Accesorios'],
  supermercado: [
    'Almacén',
    'Bebidas',
    'Lácteos',
    'Congelados',
    'Fiambrería',
    'Limpieza',
    'Perfumería',
    'Verdulería',
    'Carnicería',
  ],
  ferreteria: ['Herramientas', 'Tornillería', 'Electricidad', 'Plomería', 'Pinturería', 'Jardín', 'Construcción'],
  ropa: ['Remeras', 'Pantalones', 'Buzos y camperas', 'Calzado', 'Ropa interior', 'Accesorios'],
  general: ['General'],
};

export function categoriesForRubro(rubro: string): string[] {
  return RUBRO_CATEGORIES[rubro] ?? RUBRO_CATEGORIES.general!;
}
